module.exports = __webpack_public_path__ + "img/astron.21226f19.svg";